import { EventTypeEnum } from 'modules/profile/notifications/enums/notification-settings-enum'

export const CommunityEventTypes = [
  EventTypeEnum.COMMENT_ON_COMMUNITY_POST,
  EventTypeEnum.COMMENT_IS_LIKED,
  EventTypeEnum.COMMUNITY_NEW_PENDING_POST,
  EventTypeEnum.COMMUNITY_POST_IS_PUBLISHED,
  EventTypeEnum.COMMUNITY_POST_IS_LIKED,
  EventTypeEnum.MENTION_IN_COMMUNITY_POST,
]

export const UserEventTypes = [
  EventTypeEnum.COMMENT_REPLY_ON_COMMENT,
  EventTypeEnum.COMMENT_ON_COMMUNITY_POST,
  EventTypeEnum.COMMENT_IS_LIKED,
  EventTypeEnum.COMMUNITY_POST_IS_PUBLISHED,
  EventTypeEnum.COMMUNITY_POST_IS_LIKED,
  EventTypeEnum.MENTION_IN_COMMENT_ON_COMMUNITY_POST,
  EventTypeEnum.MENTION_IN_COMMUNITY_POST,
]
